import { initTextToggle } from '../../utils';

const ServiceHeader = () => initTextToggle('serviceHeader');

export default ServiceHeader;
